import { RevenueReportingFormTypes } from "models/formTypes";
import { TagRowIdGetter, TagsSectionItem, TagsSectionValues } from "models/propTypes/dimensionPropTypes";

export const WholeReportRowId = "wholeReport";

export const toTagRows = <TItem extends TagsSectionItem>(
  getRowId: TagRowIdGetter<TItem>,
  items?: TItem[]
): RevenueReportingFormTypes.EditTagsRow[] =>
  (items ?? []).map((item, index) => ({
    id: getRowId(item, index),
    description: item.description,
    dimensions: [...(item.dimensions ?? [])],
  }));

export const toWholeReportRows = (
  description: string,
  dimensions?: string[]
): RevenueReportingFormTypes.EditTagsRow[] => [
  { id: WholeReportRowId, description, dimensions: [...(dimensions ?? [])] },
];

export const getWholeReportDimensions = (rows?: RevenueReportingFormTypes.EditTagsRow[]) =>
  rows?.length ? [...rows[0].dimensions] : [];

export const applyRowDimensions = <TItem extends TagsSectionItem>(
  getRowId: TagRowIdGetter<TItem>,
  items?: TItem[],
  rows?: RevenueReportingFormTypes.EditTagsRow[]
): TItem[] =>
  (items ?? []).map((item, index) => {
    const row = (rows ?? []).find((r) => r.id === getRowId(item, index));
    return row ? { ...item, dimensions: [...row.dimensions] } : item;
  });

export const applyWholeReportDimensions = <TItem extends TagsSectionItem>(
  items?: TItem[],
  dimensions?: string[]
): TItem[] => (items ?? []).map((item) => ({ ...item, dimensions: [...(dimensions ?? [])] }));

export const seedTagRowsFromWholeReport = (
  rows?: RevenueReportingFormTypes.EditTagsRow[],
  dimensions?: string[]
): RevenueReportingFormTypes.EditTagsRow[] =>
  (rows ?? []).map((row) => (row.dimensions.length ? row : { ...row, dimensions: [...(dimensions ?? [])] }));

export const hasAnyTags = <TItem extends TagsSectionItem>(values: TagsSectionValues<TItem>) =>
  values.hasRowLevelDimensions
    ? [...(values.salesItems ?? []), ...(values.paymentItems ?? []), ...(values.otherItems ?? [])].some(
        (item) => (item.dimensions ?? []).length > 0
      )
    : (values.dimensions ?? []).length > 0;
